import { createFileRoute } from "@tanstack/react-router";
import Prism from "@/pages/Prism";
export const Route = createFileRoute("/prism")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Prism for PTSD | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Prism is a non-invasive, drug-free EEG neurofeedback treatment for PTSD. Learn how it works at Neuro Wellness TMS in Coral Springs, FL Learn more today.",
        },
        {
          property: "og:title",
          content: "Prism for PTSD | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Prism is a non-invasive, drug-free EEG neurofeedback treatment for PTSD. Learn how it works at Neuro Wellness TMS in Coral Springs, FL Learn more today.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/prism",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/prism",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <Prism />;
}
